import { render, staticRenderFns } from "./TypeCommentDialog.vue?vue&type=template&id=f6f1c774&"
import script from "./TypeCommentDialog.vue?vue&type=script&lang=js&"
export * from "./TypeCommentDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports